<button type="button" class="acs-trigger" [class.acs-placeholder]="!displayLabel"
        [attr.aria-expanded]="open()" [attr.aria-haspopup]="true"
        [attr.aria-label]="ariaLabel || placeholder" (click)="toggle()">
    <span class="acs-value">{{ displayLabel || placeholder }}</span>
    <span class="acs-caret" aria-hidden="true"></span>
</button>

@if (open()) {
    <div class="acs-panel" role="menu">
        <div class="acs-item acs-clear" role="menuitem" (click)="commit('')">{{ clearLabel }}</div>
        @for (g of groups; track g.label; let i = $index) {
            <div class="acs-item acs-group" role="menuitem" aria-haspopup="true"
                 [class.acs-active]="activeGroup() === i"
                 (mouseenter)="setActive(i)" (click)="setActive(i)">
                <span class="acs-group-label">{{ g.label }}</span>
                <span class="acs-arrow" aria-hidden="true">&#8250;</span>
                @if (activeGroup() === i) {
                    <div class="acs-submenu" [class.acs-submenu-left]="submenuLeft()" role="menu">
                        @for (o of g.options; track o.value) {
                            <div class="acs-item acs-leaf" role="menuitem"
                                 [class.acs-selected]="o.value === (value ?? '')"
                                 (click)="commit(o.value); $event.stopPropagation()">{{ o.label }}</div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
